import { unwrapResult } from "@reduxjs/toolkit";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { DropdownItem, DropdownMenu, DropdownToggle, Modal, UncontrolledDropdown } from "reactstrap";
import Loading from "../../../common/Loading";
import ConfirmChangeStatus from "../../../common/modals/ConfirmChangeStatus";
import ConfirmDelete from "../../../common/modals/ConfirmDelete";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  PaginationComponent,
  TooltipComponent,
  UserAvatar,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { deleteUser, fetchUsers, updateUser } from "../../../redux/slices/userSlice";
import { findUpper } from "../../../utils/Utils";

const AllAdmins = () => {
  const dispatch = useDispatch();

  const [sm, updateSm] = useState(false);
  const [tablesm, updateTableSm] = useState(false);
  const [onSearch, setonSearch] = useState(true);
  const [onSearchText, setSearchText] = useState("");
  const [modal, setModal] = useState({
    delete: false,
    status: false,
  });
  const [selectedUser, setSelectedUser] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [sort, setSortState] = useState({ column: "", direction: "" });

  const roles = useSelector((state) => state.role.roles);
  const admins = useSelector((state) => state.user.users);
  const isLoading = useSelector((state) => state.user.isLoading);
  const fetchLoading = useSelector((state) => state.user.fetchLoading);
  const [statusFilter, setStatusFilter] = useState("all");
  const [roleFilter, setRoleFilter] = useState("all");

  // TODO: fetch the admins
  useEffect(() => {
    if (roles?.data?.find((role) => role?.slug === "admin")?.id) {
      dispatch(
        fetchUsers({
          limit: itemPerPage,
          page: currentPage,
          params: {
            type: "admin",
            // role_id: roles?.data?.find((role) => role?.slug === "admin")?.id,
          },
        })
      );
    }
  }, [currentPage, dispatch, itemPerPage, roles?.data, sort]);

  // function to toggle the search option
  const toggle = () => setonSearch(!onSearch);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleDelete = async () => {
    try {
      const resultAction = await dispatch(
        deleteUser({ handleClose: () => setModal({ delete: false }), id: selectedUser?.id })
      );
      const originalPromiseResult = unwrapResult(resultAction);
      originalPromiseResult.handleClose && originalPromiseResult.handleClose();
    } catch (error) {}
  };

  const handleChangeStatus = async () => {
    try {
      const resultAction = await dispatch(
        updateUser({
          handleClose: () => setModal({ status: false }),
          id: selectedUser?.id,
          data: {
            status: !selectedUser?.status,
          },
        })
      );
      const originalPromiseResult = unwrapResult(resultAction);
      originalPromiseResult.handleClose && originalPromiseResult.handleClose();
    } catch (error) {}
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [itemPerPage]);

  const onSortChange = (column) => {
    setSortState((prev) => ({
      column,
      direction: prev.column === column ? (prev.direction === "asc" ? "desc" : "asc") : "asc",
    }));
  };

  return (
    <React.Fragment>
      <Head title="Admins List"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Admins Lists
              </BlockTitle>
              <BlockDes className="text-soft">
                <p>You have total {admins?.meta?.total} admins.</p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li className="nk-block-tools-opt">
                      <Link to="/admins/create">
                        <Button color="primary" className="btn-icon">
                          <Icon name="plus"></Icon>
                        </Button>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        {fetchLoading ? (
          <Loading />
        ) : (
          <Block>
            <DataTable className="card-stretch">
              <div className="card-inner position-relative card-tools-toggle">
                <div className="card-title-group flex justify-between">
                  {/* <div className="form-inline flex-nowrap gx-3">
                    <div className="form-wrap w-150px">
                      <select
                        className="form-select js-select2"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        <option value="all">All Status</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>

                    <div className="form-wrap w-150px">
                      <select
                        className="form-select js-select2"
                        value={roleFilter}
                        onChange={(e) => setRoleFilter(e.target.value)}
                      >
                        <option value="all">All Roles</option>
                        <option value="active">Admin</option>
                        <option value="inactive">Specialists</option>
                      </select>
                    </div>
                  </div> */}
                  {/* <div className="card-tools me-n1">
                    <ul className="btn-toolbar gx-1">
                      <li>
                        <a
                          href="#search"
                          onClick={(ev) => {
                            ev.preventDefault();
                            toggle();
                          }}
                          className="btn btn-icon search-toggle toggle-search"
                        >
                          <Icon name="search"></Icon>
                        </a>
                      </li>
                      <li className="btn-toolbar-sep"></li>
                      <li>
                        <div className="toggle-wrap">
                          <Button
                            className={`btn-icon btn-trigger toggle ${tablesm ? "active" : ""}`}
                            onClick={() => updateTableSm(true)}
                          >
                            <Icon name="menu-right"></Icon>
                          </Button>
                          <div className={`toggle-content ${tablesm ? "content-active" : ""}`}>
                            <ul className="btn-toolbar gx-1">
                              <li className="toggle-close">
                                <Button className="btn-icon btn-trigger toggle" onClick={() => updateTableSm(false)}>
                                  <Icon name="arrow-left"></Icon>
                                </Button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div> */}
                </div>
                <div className={`card-search search-wrap ${!onSearch && "active"}`}>
                  <div className="card-body">
                    <div className="search-content">
                      <Button
                        className="search-back btn-icon toggle-search active"
                        onClick={() => {
                          setSearchText("");
                          toggle();
                        }}
                      >
                        <Icon name="arrow-left"></Icon>
                      </Button>
                      <input
                        type="text"
                        className="border-transparent form-focus-none form-control"
                        placeholder="Search by user or email"
                        value={onSearchText}
                      />
                      <Button className="search-submit btn-icon">
                        <Icon name="search"></Icon>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <DataTableBody compact>
                <DataTableHead>
                  <DataTableRow>
                    <button
                      onClick={() => onSortChange("name")}
                      className="sub-text font-bold cursor-pointer w-full text-start flex justify-between"
                    >
                      <span>Full name</span>{" "}
                      <span>
                        {sort.column === "name" ? (
                          sort.direction === "asc" ? (
                            <Icon name={"sort-down-fill"} />
                          ) : (
                            <Icon name={"sort-up-fill"} />
                          )
                        ) : (
                          <Icon
                            name="sort-fill"
                            style={{
                              opacity: 0.3,
                            }}
                          />
                        )}
                      </span>
                    </button>{" "}
                  </DataTableRow>
                  <DataTableRow size="sm">
                    <button
                      onClick={() => onSortChange("email")}
                      className="sub-text font-bold cursor-pointer w-full text-start flex justify-between"
                    >
                      <span>Email</span>{" "}
                      <span>
                        {sort.column === "email" ? (
                          sort.direction === "asc" ? (
                            <Icon name={"sort-down-fill"} />
                          ) : (
                            <Icon name={"sort-up-fill"} />
                          )
                        ) : (
                          <Icon
                            name="sort-fill"
                            style={{
                              opacity: 0.3,
                            }}
                          />
                        )}
                      </span>
                    </button>{" "}
                  </DataTableRow>
                  <DataTableRow size="md">
                    <button
                      onClick={() => onSortChange("phone")}
                      className="sub-text font-bold cursor-pointer w-full text-start flex justify-between"
                    >
                      <span>Phone</span>{" "}
                      <span>
                        {sort.column === "phone" ? (
                          sort.direction === "asc" ? (
                            <Icon name={"sort-down-fill"} />
                          ) : (
                            <Icon name={"sort-up-fill"} />
                          )
                        ) : (
                          <Icon
                            name="sort-fill"
                            style={{
                              opacity: 0.3,
                            }}
                          />
                        )}
                      </span>
                    </button>{" "}
                  </DataTableRow>

                  <DataTableRow size="md">
                    <span className="sub-text font-bold">Role</span>
                  </DataTableRow>

                  <DataTableRow size="md">
                    <button className="sub-text font-bold cursor-pointer w-full text-start flex justify-between">
                      <span>Status</span>{" "}
                    </button>
                  </DataTableRow>

                  <DataTableRow className="nk-tb-col-tools text-end">
                    <span className="sub-text font-bold">Action</span>
                  </DataTableRow>
                </DataTableHead>
                {/*Head*/}
                {admins?.data?.length > 0
                  ? admins?.data?.map((item) => {
                      return (
                        <DataTableItem key={item?.id}>
                          <DataTableRow>
                            <div className="user-card">
                              <UserAvatar
                                theme={item?.avatarBg}
                                className="xs"
                                text={findUpper(item?.name?.toUpperCase())}
                                image={item?.image}
                              ></UserAvatar>
                              <div className="user-info">
                                <span className="tb-lead">{item?.name} </span>
                              </div>
                            </div>
                          </DataTableRow>

                          <DataTableRow size="sm">
                            <span>{item?.email}</span>
                          </DataTableRow>
                          <DataTableRow size="md">
                            <span>{item?.phone}</span>
                          </DataTableRow>

                          <DataTableRow size="md">
                            <span>{item?.role?.name}</span>
                          </DataTableRow>

                          <DataTableRow size="md">
                            <button
                              onClick={() => {
                                setModal((prev) => ({ ...prev, status: true }));
                                setSelectedUser(item);
                              }}
                              className={`${item?.status ? "bg-green-500" : "bg-red-500"} p-1 rounded-lg text-white`}
                            >
                              {item?.status ? "Active" : "Suspended"}
                            </button>
                          </DataTableRow>

                          <DataTableRow className="nk-tb-col-tools">
                            <ul className="nk-tb-actions gx-1">
                              <Link to={`/admins/edit/${item?.id}`} className="nk-tb-action-hidden">
                                <TooltipComponent
                                  tag="a"
                                  containerClassName="btn btn-trigger btn-icon"
                                  id={"edit" + item.id}
                                  icon="edit-alt-fill"
                                  direction="top"
                                  text="Edit"
                                />
                              </Link>

                              <li
                                className="nk-tb-action-hidden"
                                onClick={() => {
                                  setModal((prev) => ({ ...prev, delete: true }));
                                  setSelectedUser(item);
                                }}
                              >
                                <TooltipComponent
                                  tag="a"
                                  containerClassName="btn btn-trigger btn-icon"
                                  id={"delete" + item?.id}
                                  icon="trash-fill"
                                  direction="top"
                                  text="Delete"
                                />
                              </li>

                              <li>
                                <UncontrolledDropdown>
                                  <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                                    <Icon name="more-h"></Icon>
                                  </DropdownToggle>
                                  <DropdownMenu end>
                                    <ul className="link-list-opt no-bdr">
                                      <Link to={`/admins/edit/${item?.id}`} className="p-0">
                                        <DropdownItem
                                          tag="a"
                                          href="#edit"
                                          // onClick={(ev) => {
                                          //   ev.preventDefault();
                                          // }}
                                        >
                                          <Icon name="edit"></Icon>
                                          <span>Edit</span>
                                        </DropdownItem>
                                      </Link>

                                      <li className="cursor-pointer">
                                        <DropdownItem
                                          tag="a"
                                          onClick={(ev) => {
                                            setModal((prev) => ({ ...prev, delete: true }));
                                            setSelectedUser(item);
                                          }}
                                        >
                                          <Icon name="trash"></Icon>
                                          <span>Delete</span>
                                        </DropdownItem>
                                      </li>
                                    </ul>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </li>
                            </ul>
                          </DataTableRow>
                        </DataTableItem>
                      );
                    })
                  : null}
              </DataTableBody>
              <div className="card-inner">
                {admins?.data?.length > 0 ? (
                  <PaginationComponent
                    itemPerPage={itemPerPage}
                    totalItems={admins?.meta?.total}
                    paginate={paginate}
                    currentPage={currentPage}
                    setItemPerPage={setItemPerPage}
                  />
                ) : (
                  <div className="text-center">
                    <span className="text-silent">No data found</span>
                  </div>
                )}
              </div>
            </DataTable>
          </Block>
        )}
      </Content>

      <Modal isOpen={modal.delete} className="modal-dialog-centered" size="sm">
        <ConfirmDelete onDelete={handleDelete} onClose={() => setModal({ delete: false })} isLoading={isLoading} />
      </Modal>

      <Modal isOpen={modal.status} className="modal-dialog-centered" size="sm">
        <ConfirmChangeStatus
          onChange={handleChangeStatus}
          onClose={() => setModal({ status: false })}
          isLoading={isLoading}
        />
      </Modal>
    </React.Fragment>
  );
};
export default AllAdmins;
